import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import OfferProductCard from "./OfferProductCard";
import axios from "axios";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

export default function OfferSwiper() {
  const [offerProducts, setOfferProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const fetchDiscountProducts = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/discounts`);
        const products = response.data.discountedProducts.map(product => {
          const priceValues = Object.values(product.prices).map(price => parseInt(price));
          const maxOriginalPrice = Math.max(...priceValues);
          
          let discountedPrice, discount;
          
          if (product.discountedPrices) {
            // Handle products with actual discounted prices (regardless of offer type)
            const discountedPriceValues = Object.values(product.discountedPrices).map(price => parseFloat(price));
            discountedPrice = Math.max(...discountedPriceValues);
            discount = Math.round((1 - discountedPrice / maxOriginalPrice) * 100);
          } else {
            // Handle products without discounted prices (just marked as special offer)
            discountedPrice = maxOriginalPrice; // Same as original price
            discount = 0; // No actual discount, just marked as offer
          }

          return {
            id: product.id,
            image: product.images[0], // Using the first image
            name: product.name,
            originalPrice: maxOriginalPrice,
            discountedPrice: discountedPrice,
            discount: discount,
            offerType: product.offerType // Include offer type for potential use in OfferProductCard
          };
        });
        
        setOfferProducts(products);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchDiscountProducts();
  }, []);

  if (loading) {
    return <div className="w-full px-4 md:px-8 py-6 text-center">Loading offers...</div>;
  }

  if (error) {
    return <div className="w-full px-4 md:px-8 py-6 text-center text-red-500">Error loading offers: {error}</div>;
  }

  if (offerProducts.length === 0) {
    return <div className="w-full px-4 md:px-8 py-6 text-center">No current offers available</div>;
  }

  return (
    <div className="w-full px-4 md:px-8 py-6 relative">
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={20}
        slidesPerView={1}
        pagination={{
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class="${className} w-2 h-2 bg-[#D4AF37] rounded-full mx-1"></span>`;
          },
        }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        breakpoints={{
          480: { slidesPerView: 1, spaceBetween: 15 },
          768: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 3, spaceBetween: 25 },
          1280: { slidesPerView: 4, spaceBetween: 30 },
        }}
        className="offer-swiper"
      >
        {offerProducts.map((product, index) => (
          <SwiperSlide key={index} className="py-4">
            <div className="flex justify-center">
              <OfferProductCard product={product} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}